import React from 'react';
import { FiLock, FiUnlock } from 'react-icons/fi';
import { lockVaultNoticeLabel } from '../constants';

export default function StorageBoxToast({ notice }) {
  if (!notice) return null;

  if (notice.type === 'lock-vault') {
    const Icon = notice.variant === 'unlocked' ? FiUnlock : FiLock;
    return (
      <div className="sb-toast sb-toast--lock-vault" role="status">
        <Icon className="sb-toast__icon" aria-hidden />
        <span>{lockVaultNoticeLabel(notice.variant)}</span>
      </div>
    );
  }

  return (
    <div className="sb-toast" role="status">
      {notice.message}
    </div>
  );
}
